import { Eye, CheckCircle2, XCircle, Clock } from 'lucide-react';
import { dateFR, modeCharte } from '../charte-formateur/StatutCharte';
import { ConformiteSousTraitant } from '../formateurs/ConformiteSousTraitant';

const BoutonPdf = ({ onClick, testId, label }) => (
  <button type="button" onClick={onClick} data-testid={testId} title={label}
    className="inline-flex items-center gap-1.5 rounded-full border border-slate-200 px-3 py-1 text-xs font-medium text-slate-700 transition-colors duration-200 hover:border-[#8DC63F] hover:bg-[#8DC63F]/10">
    <Eye className="h-3.5 w-3.5" /> PDF
  </button>
);

const Titre = ({ children }) => <p className="mb-2 text-[11px] font-semibold uppercase tracking-[0.14em] text-slate-400">{children}</p>;

export const LigneFormateurAdmin = ({ f, onPdf }) => {
  const nom = `${f.prenom || ''} ${f.nom || ''}`.trim() || f.email;
  const id = f.user_id;
  return (
    <div className="grid gap-5 rounded-2xl border border-slate-200 bg-white p-5 sm:p-6 shadow-sm transition-shadow duration-200 hover:shadow-md lg:grid-cols-[1fr_1fr_1.6fr]" data-testid={`admin-formateur-${id}`}>
      <div className="min-w-0">
        <p className="truncate font-semibold text-[#0F172A]" data-testid={`admin-formateur-nom-${id}`}>{nom}</p>
        <p className="truncate text-xs text-slate-500">{f.email}</p>
      </div>
      <div data-testid={`admin-formateur-charte-${id}`}>
        <Titre>Charte</Titre>
        {f.charte ? (
          <div className="flex flex-wrap items-center gap-2">
            <span className="inline-flex items-center gap-1.5 rounded-full bg-emerald-50 px-3 py-1 text-xs font-semibold text-emerald-700">
              <CheckCircle2 className="h-3.5 w-3.5" /> Acceptée le {dateFR(f.charte.date_signature)}
            </span>
            <BoutonPdf testId={`admin-formateur-charte-pdf-${id}`} label="Voir la charte signée" onClick={() => onPdf(null, `Charte – ${nom}`, `/charte-formateurs/pdf/${id}`)} />
            <p className="w-full text-xs text-slate-500">{modeCharte(f.charte)}</p>
          </div>
        ) : (
          <span className="inline-flex items-center gap-1.5 rounded-full bg-red-50 px-3 py-1 text-xs font-semibold text-red-700"><XCircle className="h-3.5 w-3.5" /> Non signée</span>
        )}
      </div>
      <div data-testid={`admin-formateur-lettres-${id}`}>
        <Titre>Lettres de mission signées</Titre>
        {f.lettres_signees.length === 0 && <p className="text-sm text-slate-400">Aucune</p>}
        <ul className="space-y-2">
          {f.lettres_signees.map((l) => (
            <li key={l.lettre_id} className="flex flex-wrap items-center gap-2 text-sm" data-testid={`admin-lettre-${l.lettre_id}`}>
              <span className="min-w-0 flex-1 truncate text-slate-700">{l.intitule_formation || 'Lettre de mission'}{l.dates ? ` · ${l.dates}` : ''}</span>
              <span className="text-xs text-slate-500">signée le {dateFR(l.date_signature_formateur)}</span>
              <BoutonPdf testId={`admin-lettre-pdf-${l.lettre_id}`} label="Voir la lettre de mission" onClick={() => onPdf(null, `Lettre de mission – ${nom}`, `/lettres-mission/${l.lettre_id}/pdf`)} />
            </li>
          ))}
        </ul>
        {f.lettres_en_attente > 0 && (
          <p className="mt-2 inline-flex items-center gap-1.5 text-xs font-medium text-amber-700" data-testid={`admin-formateur-attente-${id}`}>
            <Clock className="h-3.5 w-3.5" /> {f.lettres_en_attente} en attente de signature
          </p>
        )}
      </div>
      <div className="lg:col-span-3 -mt-4"><ConformiteSousTraitant formateurId={id} /></div>
    </div>
  );
};
